// test1721
(1721 && 0);
